import { render, staticRenderFns } from "./AddTransferInfoModal.vue?vue&type=template&id=38474ff2&scoped=true&"
import script from "./AddTransferInfoModal.vue?vue&type=script&lang=js&"
export * from "./AddTransferInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTransferInfoModal.vue?vue&type=style&index=0&id=38474ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38474ff2",
  null
  
)

export default component.exports